var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine container"},[_c('side',{staticClass:"side"}),_c('div',{staticClass:"rightMain"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }